import type { LiveOddsAdminReadiness, LiveOddsCandidateScope, LiveOddsMappingCandidate, LiveOddsRefreshPreview, LiveOddsRefreshScope, LiveOddsRefreshWriteResult } from './types'
import { authApiClient } from '~/lib/api-client'
import { parseLiveOddsLifecycleJson } from './lifecycle-api-error'

const liveOddsClient = authApiClient.api['live-odds']

export async function getLiveOddsReadiness(scope?: LiveOddsCandidateScope) {
  const response = await liveOddsClient.admin.readiness.$get({
    query: scope ?? {},
    header: { Authorization: '' },
  })
  return parseLiveOddsLifecycleJson<LiveOddsAdminReadiness>(response)
}

export async function listLiveOddsCandidates(reviewStatus: LiveOddsMappingCandidate['reviewStatus'] | undefined = 'pending', scope?: LiveOddsCandidateScope) {
  const response = await liveOddsClient.admin.candidates.$get({
    query: {
      ...(reviewStatus ? { reviewStatus } : {}),
      ...(scope ?? {}),
      limit: 200,
    },
    header: { Authorization: '' },
  })
  return parseLiveOddsLifecycleJson<LiveOddsMappingCandidate[]>(response)
}

export async function approveLiveOddsCandidates(candidateIds: string[], scope: LiveOddsCandidateScope) {
  const response = await liveOddsClient.admin.candidates['batch-approve'].$post({
    json: { candidateIds, ...scope },
    header: { Authorization: '' },
  })
  return parseLiveOddsLifecycleJson<{
    approvedCount: number
    skippedCount: number
    createdMappingIds: string[]
    validationErrors: Array<{ candidateId: string, message: string }>
  }>(response)
}

export async function updateLiveOddsCandidateStatus(candidateIds: string[], reviewStatus: 'rejected' | 'needs_review', scope: LiveOddsCandidateScope) {
  const response = await liveOddsClient.admin.candidates.status.$post({
    json: { candidateIds, reviewStatus, ...scope },
    header: { Authorization: '' },
  })
  return parseLiveOddsLifecycleJson<{ updatedCount: number }>(response)
}

export async function previewLiveOddsRefresh(input: { requestBudget: number, scope: LiveOddsRefreshScope }) {
  const response = await liveOddsClient.admin.refresh.preview.$post({
    json: {
      requestBudget: input.requestBudget,
      scope: input.scope,
    },
    header: { Authorization: '' },
  })
  return parseLiveOddsLifecycleJson<LiveOddsRefreshPreview>(response)
}

export async function writeLiveOddsRefresh(input: { acceptedPreview: { previewId: string } }) {
  const response = await liveOddsClient.admin.refresh.write.$post({
    json: input,
    header: { Authorization: '' },
  })
  return parseLiveOddsLifecycleJson<LiveOddsRefreshWriteResult>(response)
}
